import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import SpeechBalloon from '../../../domain/entities/SpeechBalloon';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexSpeechBalloonsSuccess: {
      const result = action.payload as PaginatedResult<SpeechBalloon>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
